import { IMAGES } from "./images";

export const ORISA = [
  {
    name: "Ọbàtálá",
    domain: "Creation, Purity & Wisdom",
    color: "White",
    slug: "obatala",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/lesqn595_C99EB29B-C378-412C-8D6B-8582A319CE83.png",
    description:
      "The senior Òrìṣà, sculptor of human bodies from clay. Ọbàtálá represents purity, ethics, calm wisdom, patience, and human dignity. Robed in white, his power flows from character rather than force. Read the full profile →",
  },
  {
    name: "Ṣàngó",
    domain: "Thunder, Lightning & Justice",
    color: "Red & White",
    slug: "sango",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/a2364pya_C27A98B4-B9B9-46D9-A917-1DBFA3221F19.png",
    description:
      "A legendary Aláàfin of Ọ̀yọ́ who became the Òrìṣà of thunder. Ṣàngó embodies power, virility, and fierce justice. His double-headed axe (ọ̀ṣẹ́) and the bàtá drum are his emblems. Read the full profile →",
  },
  {
    name: "Ọ̀ṣun",
    domain: "Rivers, Love, Fertility & Wealth",
    color: "Gold & Yellow",
    slug: "osun",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/ci7xn7am_032C1279-28B6-4D30-9C51-10BAEC037F96.png",
    description:
      "Òrìṣà of fresh water, beauty, love, and prosperity — soft yet formidable. Ọ̀ṣun embodies feminine power, diplomacy, and healing. Her sacred grove at Òṣogbo is a UNESCO World Heritage Site. Read the full profile →",
  },
  {
    name: "Ògún",
    domain: "Iron, War, Labour & Technology",
    color: "Green & Black",
    slug: "ogun",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/zrnkf1rr_4313A146-7463-49AE-B2D6-4A07C976C7ED.png",
    description:
      "The Òrìṣà of iron, tools, and clearing the path — master of the forge and patron of blacksmiths, hunters, warriors, and today drivers and engineers. Ògún embodies the dignity of labour and the power to transform the world through work. Read the full profile →",
  },
  {
    name: "Yemọja",
    domain: "Motherhood & the Waters",
    color: "Blue & White",
    slug: "yemoja",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/npxdzhel_97F526FD-5A4A-44A0-88E7-B4F05A9B203D.png",
    description:
      "The great mother Òrìṣà — 'Mother of Fish' — of rivers in Yorùbáland and the ocean across the diaspora. Yemọja is the nurturing, protective source of life, guardian of women and children, revered as Yemayá and Iemanjá worldwide. Read the full profile →",
  },
  {
    name: "Ọya",
    domain: "Winds, Storms & Transformation",
    color: "Deep Red & Gold",
    slug: "oya",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/tm545erw_19153ECB-E366-4E0B-8027-5A722CCA96DD.png",
    description:
      "Warrior goddess of winds, storms, and the Niger River, and guardian of the gateway between life and death. Ọya, companion of Ṣàngó, is a fierce force of change, courage, and feminine leadership who sweeps away the old to make room for the new. Read the full profile →",
  },
  {
    name: "Èṣù",
    domain: "The Crossroads & Divine Messenger",
    color: "Black & Red",
    slug: "esu",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/c05cbdkq_3E2BEDE8-02E6-4BF5-8DE1-2DA5A0B813CC.png",
    description:
      "The messenger who carries prayers and offerings between humans and the Òrìṣà, and the keeper of the crossroads and àṣẹ. Èṣù embodies choice, change, and consequence — not evil, but the reminder that every path has a cost. Read the full profile →",
  },
  {
    name: "Ọ̀rúnmìlà",
    domain: "Wisdom, Destiny & Ifá",
    color: "Green & Yellow",
    slug: "orunmila",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/24j39fpt_35E1580F-E9E4-4CDB-8245-4582324B17A8.png",
    description:
      "The Òrìṣà of wisdom and divination, witness to each soul's chosen destiny. Ọ̀rúnmìlà is the voice of Ifá — a UNESCO-recognised system of 256 Odù, sacred poetry, mathematics, and ethics carried in living memory. Read the full profile →",
  },
  {
    name: "Ọ̀ṣọ́ọ̀sì",
    domain: "The Hunt & the Forest",
    color: "Blue & Green",
    slug: "osoosi",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/3tn9t08q_7896078ba072b40061fd2070fe1e09f218bf6b67ef3e31dc905ec17c5a06e409.jpeg",
    description:
      "The Divine Hunter — Òrìṣà of hunting, the forest, tracking, precision, provision, and protection. Ọ̀ṣọ́ọ̀sì embodies focus, patience, and the specialised knowledge of the wilderness. Read the full profile →",
  },
  {
    name: "Ọbalúayé",
    domain: "Earth, Disease, Healing & Renewal",
    color: "Earth tones",
    slug: "obaluaye",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/37flr6fa_394AC1D5-5E5E-434A-B4AE-92B6720C8143.png",
    description:
      "The Òrìṣà of the earth, illness, and healing — feared and deeply respected. Also called Ṣọ̀pọ̀nná, Ọ̀mọlú, or Babalúayé, he governs epidemics and their cure, teaching humility, compassion, and the possibility of renewal. Read the full profile →",
  },
];
